import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import type { DocumentationType } from '../../../common/types/documentation';
import type { DocumentationStatistic as DocumentationStatisticType } from '../../../common/types/statistics/fbStatistics';

import BaseDocumentation from './BaseDocumentation';
import GroupStatistics from './GroupStatistics';
import SocialMediaStatistics from './SocialMediaStatistics';

const formOrder: {
  key: Exclude<DocumentationType, 'group' | 'socialMedia'>;
  label: string;
  showParticipants: boolean;
}[] = [
  { key: 'workgroup', label: 'Arbeitskreise', showParticipants: false },
  { key: 'supervision', label: 'Supervision', showParticipants: false },
  {
    key: 'takeFurtherEducation',
    label: 'Fortbildung nehmen',
    showParticipants: false,
  },
  {
    key: 'giveFurtherEducation',
    label: 'Fortbildung geben',
    showParticipants: true,
  },
  {
    key: 'meetingIntern',
    label: 'Besprechung intern',
    showParticipants: true,
  },
  {
    key: 'meetingExtern',
    label: 'Besprechung extern',
    showParticipants: true,
  },
  {
    key: 'managementTask',
    label: 'Geschäftsführungstätigkeit',
    showParticipants: true,
  },
  {
    key: 'publicRelation',
    label: 'Öffentlichkeitsarbeit',
    showParticipants: true,
  },
];

type Props = {
  statistics: DocumentationStatisticType;
};

function DocumentationStatistics({ statistics }: Props) {
  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px 0',
        padding: '20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Stack spacing={2}>
        <Typography fontSize='1.2rem' mb={2}>
          Sonstige Dokumentation
        </Typography>
        {formOrder.map(({ key, label, showParticipants }) => {
          if (key !== 'shortContact' && key !== 'departmentTraining') {
            const statistic = statistics[key];

            return (
              <BaseDocumentation
                key={key}
                heading={label}
                numberOfAppointments={statistic.numberOfAppointments}
                numberOfHours={statistic.numberOfHours}
                {...(showParticipants ? { numberOfParticipants: statistic.numberOfParticipants } : {})}
              />
            );
          }
        })}
        <GroupStatistics statistics={statistics} />
        <SocialMediaStatistics statistics={statistics} />
      </Stack>
    </Paper>
  );
}

export default DocumentationStatistics;
